import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })

  let question_templates = useDataValue({
    viewPath: props.viewPath,
    context: 'question_templates',
  })

  return function onChange(value) {
    change(next => {
      next.question_type_id = value
      next.question_template =
        question_templates.find(question => question.id === value) || {}
    })
  }
}
